module.exports = __webpack_public_path__ + "img/framework.22f5f596.png";